export default "__VITE_ASSET__CT5PIi$5__"